import { render, staticRenderFns } from "./faultreport.vue?vue&type=template&id=0db41392&scoped=true&"
import script from "./faultreport.vue?vue&type=script&lang=js&"
export * from "./faultreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db41392",
  null
  
)

export default component.exports